import { render } from "./payment-hdp-form.vue?vue&type=template&id=c31ef272"
import script from "./payment-hdp-form.vue?vue&type=script&lang=js"
export * from "./payment-hdp-form.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__